import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextInput, Paper, Title, Text, Container, Button, PasswordInput } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import AuthLogo from '@components/auth-logo';
import { confirmPassword } from '@services/authentication';
import AuthModal from '@components/auth-modal';
import classes from './auth-common.module.css';

function Confirmation() {
  const location = useLocation();
  const [opened, { open, close }] = useDisclosure(false);
  const stateUsername = (location.state as { username?: string } | null)?.username || '';
  const queryParams = new URLSearchParams(location.search);
  const queryUsername = queryParams.get('login_name') || '';
  const initialUsername = stateUsername || queryUsername || '';
  const [username, setUsername] = useState<string>(initialUsername);
  const [code, setCode] = useState(queryParams.get('code') || '');
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setError('');
    if (password !== confPassword) {
      setError('Passwords do not match!');
      return;
    }

    confirmPassword(username, code, password)
      .then(() => {
        open(); // AuthModal
      })
      .catch((err) => {
        setError((err as Error).message || 'An error occurred');
      });
  };

  return (
    <Container size={420} my={40}>
      <AuthLogo />

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <Title ta="center" order={2} className={classes.title}>
          Confirm Password Reset
        </Title>
        <Text ta="center" c="dimmed" size="sm" mt={5} mb={30}>
          Please use the code that was sent via email to reset your password.
        </Text>

        <TextInput
          label="Email"
          placeholder="user@example.com"
          required
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <TextInput
          label="Confirmation Code"
          placeholder="Confirmation Code"
          required
          mt="md"
          onChange={(e) => setCode(e.target.value)}
          value={code}
        />
        <PasswordInput
          label="New Password"
          placeholder="Your password"
          required
          mt="md"
          onChange={(e) => setPassword(e.target.value)}
        />
        <PasswordInput
          label="Confirm Password"
          placeholder="Your password"
          required
          mt="md"
          onChange={(e) => setConfPassword(e.target.value)}
        />

        <Button fullWidth mt="xl" onClick={(event) => handleClick(event)}>
          Change Password
        </Button>
        <Button variant="light" fullWidth mt="xl" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        {error && (
          <Text c="red" pt={20}>
            {error}
          </Text>
        )}
      </Paper>
      <AuthModal
        opened={opened}
        close={close}
        navTo="/login"
        state={{ username }}
        title="Password Reset Successful!"
        message="You can now login with your credentials"
      />
    </Container>
  );
}

export default Confirmation;
